<!-- 企业级-授权管理-设备中心 -->
<template>
  <div class="mainArea CDevieCenter">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="authCont">
          <div class="authLeft">
            <div class="tit">设备位置</div>
            <div class="authTree pd10">
              <el-tree
                class="defineTree"
                ref="tree"
                v-loading="sceneData.loading"
                highlight-current
                :data="sceneData.list"
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="defaultProps"
                @node-click="getNodeList">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span
                    class="label"
                    :class="data.space_id === sceneData.selected ? 'selected' : ''">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="authRight">
            <cdevicecomponent></cdevicecomponent>
          </div>
        </div>
      </div>
      
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import cdevicecomponent from "./CDeviceComponent.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import * as expConfig from "../../../../static/js/exp/config.js"
  import { expSceneApi } from "../../../../static/js/exp/scene.js"

  export default {
    name: 'ExpCDeviceCenter',
    components: {
      CBreadCrumb,
      cdevicecomponent
    },
    data() {
      return {
        checkList:[],
        // 位置列表数据
        sceneData: {
          // 位置列表
          list: [],
          loading: false,
          selected: 2,
        },
        // 树形控件配置
        defaultProps: {
          id:'space_id',
          children: 'children',
          label: 'space_name'
        },

        space_id:[],
        
      };
    },
    mounted(){

    },
    created: async function () {
      this.getSceneList()
    },
    methods: {
      // 获取位置列表
      getSceneList: async function (selected) {
        let vm = this
        let res = await expSceneApi.getSceneList()
        vm.sceneData.list = res.data
      },
      //点击节点
      getNodeList(data){
        // console.log('data', data)
        if (data.level < 1) return
        this.sceneData.selected = data.space_id
      },
    },
    watch: {
    }
  }
</script>

<style lang="scss">
.CDevieCenter{
  .w110{ width: 110px;}
  .mt10{ margin-top: 10px;}
  .el-tree{
    background: #f0f0f0;
  }
  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background: none;
    .label{
      // color: #409EFF;
    }
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    .authCont{
      display: flex;
      min-height: 800px;
      .authLeft{
        overflow-y:auto;
        width: 335px;
        flex-shrink: 0;
        background: #f0f0f0;
        .tit{
          height: 48px;
          line-height: 48px;
          padding: 0 20px;
          background: #b5b5b5;
          font-size:24px;
          color: #666;
        }
        .pd10{ padding: 10px;}
      }
      .authRight{
        flex-grow:1;
        .operDiv{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .colRed{ color: red;}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExpPage/CSceneManage/CDeviceCenter.vue